<app-page-title-banner-v02-h00-c00-cookie-policy></app-page-title-banner-v02-h00-c00-cookie-policy>
<div class="contentSection">
  <div class="contentSectionWrap">
    <div class="contentSectionDetail">
      <p class="overview">
        Tata Consultancy Services Limited uses cookies (small text files placed on your device) and similar technologies
        to provide our websites and to help collect data. The text in a cookie often consists of a string of numbers and
        letters that uniquely identifies your computer, but it can contain other information as well.
      </p>
      <h2 class="subTitle01-1">Our Use of Cookies and Similar Technologies.</h2>
      <p>Tata Consultancy Services uses cookies and similar technologies for several purposes, which may include:</p>
      <ul class="dataList">
        <li><span class="subTitle04">Storing your Preferences</span> and Settings. Settings that enable our website to
          operate correctly or that
          maintain your preferences over time may be stored on your device.
        </li>
        <li><span class="subTitle04"> Sign-in and Authentication.</span> When you sign into our website using your
          credentials, we store a unique
          ID number, and the time you signed in, in an encrypted cookie on your device. This cookie allows you to move
          from page to page within the site without having to sign in again on each page. You can also save your
          sign-in information so you do not have to sign in each time you return to the site.
        </li>
        <li><span class="subTitle04">Security. </span> Tata Consultancy Services sets cookies when you visit our
          websites. Tata Consultancy Services sets cookies that are technical and necessary for the function of the
          website, for example, that allow you to browse the website and use the different options included in this for
          the management of the website and enable its functions and services, such as controlling data traffic and
          communication, identifying the session, using safety elements during browsing.</li>
      </ul>
      <p>
        Some of the cookies we commonly use are listed below. This list is not exhaustive, but it is intended to
        illustrate the main reasons we typically set cookies. If you visit one of our websites, the site may set some or
        all of the following cookies:
      </p>
      <p>
        A cookie is a small piece of data (text file) that a website – when visited by a user – asks your browser to
        store on your device in order to remember information about you, such as your language preference or login
        information. Those cookies are set by us and called first-party cookies. More specifically, we use cookies and
        other tracking technologies for the following purposes:
      </p>
      <div class="tableWrp">
        <table>
          <thead>
            <tr>
              <th class="subTitle04">Cookie Name</th>
              <th class="subTitle04">Description</th>
              <th class="subTitle04">Cookie Category</th>
              <th class="subTitle04">Domain</th>
              <th class="subTitle04">Expiry</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>auth-token</td>
              <td>
                General purpose platform session cookie, used by sites written in JSP. Usually used to maintain an
                anonymous user session by the server.
              </td>
              <td>{{cookieCat}}</td>
              <!-- 10.251.230.131:8061 -->
              <td>First Party - Strictly Necessary</td>
              <td>Session</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h2 class="subTitle01-1">How to Control Cookies Manually</h2>
      <p>You can set your browser:</p>
      <ul class="listText">
        <li class="subTitle04"><span class="bullet"></span> To allow all cookies</li>
        <li class="subTitle04"><span class="bullet"></span> To allow only 'trusted' sites to send them</li>
        <li class="subTitle04"><span class="bullet"></span> To accept only those cookies from websites you are currently
          using.</li>
      </ul>
      <p>We recommend not to block all cookies because TCS.com website uses them to work properly.</p>
      <p>Please read below points to find out how to manage cookies in the major browsers.</p>
      <div class="boxContent">
        <h3>Google Chrome:</h3>
        <p>Click on the “Menu” tab in the upper-right corner and then click on “Settings”. </p>
        <h4 class="subTitle04">To block cookies: </h4>
        <p>
          Settings → Click on “Advanced” to expand → Under Privacy and Security, Click on “Content Settings” → Click on
          “Cookies” → To block cookies, Click on toggle button next to this line “Allow sites to save and read cookie
          data (recommended)“ → This will block the cookies.
        </p>
        <h4 class="subTitle04">To check cookies:</h4>
        <p>
          Settings → Click on “Advanced” to expand → Under Privacy and Security → Click on “Content Settings” → Click
          on “Cookies” → See all cookies and site data → Click on the website and check the cookies used in that
          particular site.
        </p>
      </div>
      <!-- <div class="boxContent">
        <h3>Internet Explorer:</h3>
        <p>Click on the “Menu” tab in the upper-right corner and then click on “Settings”. </p>
        <h4 class="subTitle04">To block cookies: </h4>
        <p>
          Settings → Click on “Advanced” to expand → Under Privacy and Security, Click on “Content Settings” → Click on
          “Cookies” → To block cookies, Click on toggle button next to this line “Allow sites to save and read cookie
          data (recommended)“ → This will block the cookies.
        </p>
        <h4 class="subTitle04">To check cookies:</h4>
        <p>
          Settings → Click on “Advanced” to expand → Under Privacy and Security → Click on “Content Settings” → Click
          on “Cookies” → See all cookies and site data → Click on the website and check the cookies used in that
          particular site.
        </p>
      </div> -->
    </div>
  </div>
</div>
